module.exports = __webpack_public_path__ + "img/riointbig3.ec1976c0.png";